import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { DxHttpModule } from 'devextreme-angular/http';
import {
  SideNavOuterToolbarModule,
  SideNavInnerToolbarModule,
  SingleCardModule,
} from './layouts';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './shared/interceptors/interceptors/http-error.service';
import {
  FooterModule,
  ResetPasswordFormModule,
  CreateAccountFormModule,
  ChangePasswordFormModule,
  LoginFormModule,
} from './shared/components';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { UnauthenticatedContentModule } from './unauthenticated-content';
import { AppRoutingModule } from './app-routing.module';
import { VisaApplicationListComponent } from './pages/visa-application-list/visa-application-list.component';
import { EventlogComponent } from './pages/eventlog/eventlog.component';
import {
  DxAccordionModule,
  DxBulletModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDropDownButtonModule,
  DxHtmlEditorModule,
  DxListModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxSliderModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxTileViewModule,
  DxToastModule,
  DxLoadPanelModule,
  DxFileUploaderModule,
  DxTextAreaModule,
  DxLookupModule,
} from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { ImageSrcDirective } from './shared/directives/image-src.directive';
import { DxPieChartModule, DxChartModule } from 'devextreme-angular'; // Import DxPieChartModule
import { ImageUploaderComponent } from './shared/components';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DefinationComponent } from './pages/defination/defination.component';
import { AboutComponent } from './pages/about/about.component';
import { PoliciesKvkkComponent } from './pages/policies-kvkk/policies-kvkk.component';
import { FrequentlyAskedQuestionsComponent } from './pages/frequently-asked-questions/frequently-asked-questions.component';
import { BlogComponent } from './pages/blog/blog.component';
import { ApplicationDetailComponent } from './shared/components/application-detail-panel/application-detail-panel.component';
import { JwtInterceptor } from './shared/interceptors/interceptors/JwtInterceptor ';
import { EventlogDetailComponent } from './shared/components/eventlog-detail/eventlog-detail.component';
import { FormsModule } from '@angular/forms';
import { NumberFormatterPipe } from './shared/pipes/number-formatter.pipe';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { CardComponent } from './shared/components/card/card.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { SiteDescriptionComponent } from './pages/site-description/site-description.component';
import { PercentageComponent } from './pages/percentage/percentage.component';
import { VisaDefinationComponent } from './pages/visa-definition/visa-definition.component';
import { DiscountDefinitionComponent } from './pages/discount-definition/discount-definition.component';
import { AdminSliderComponent } from './pages/slider/slider.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    VisaApplicationListComponent,
    EventlogComponent,
    DefinationComponent,
    VisaDefinationComponent,
    DiscountDefinitionComponent,
    AboutComponent,
    PoliciesKvkkComponent,
    FrequentlyAskedQuestionsComponent,
    BlogComponent,
    ImageUploaderComponent,
    ImageSrcDirective,
    ApplicationDetailComponent,
    EventlogDetailComponent,
    NumberFormatterPipe,
    DashboardComponent,
    CardComponent,
    SubscribeComponent,
    SiteDescriptionComponent,
    PercentageComponent,
    AdminSliderComponent,
  ],
  imports: [
    BrowserModule,
    DxHttpModule,
    HttpClientModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    ResetPasswordFormModule,
    CreateAccountFormModule,
    ChangePasswordFormModule,
    LoginFormModule,
    UnauthenticatedContentModule,
    AppRoutingModule,
    DxButtonModule,
    DxDataGridModule,
    DxDropDownButtonModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    CommonModule,
    DxBulletModule,
    DxTemplateModule,
    DxPieChartModule,
    DxChartModule,
    DxPopupModule,
    DxToastModule,
    DxHtmlEditorModule,
    DxTagBoxModule,
    DxTileViewModule,
    DxListModule,
    DxCheckBoxModule,
    DxAccordionModule,
    DxFileUploaderModule,
    DxCheckBoxModule,
    DxSliderModule,
    DxLoadPanelModule,
    DxTextAreaModule,
    FormsModule,
    DxPieChartModule,
    DxLookupModule
  ],
  providers: [
    AuthService,
    ScreenService,
    AppInfoService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
